import { useDocumentDataOnce } from 'react-firebase-hooks/firestore';
import { useFirebaseProviders } from 'modules/Firebase/FirebaseProvider';

export default function useDogDetails(id) {
    const { firestore } = useFirebaseProviders();
    return useDocumentDataOnce(firestore.doc(`dogs/${id}`));
}
